import { SelfInspectionDefinitionV2Response } from './installation-reporting-mdu-bff.entities';
import { InstallationReportSelfInspectionItem } from './installation-reporting-mdu-section.types';

export const mapSelfInspectionDefinition = (
  definition: SelfInspectionDefinitionV2Response,
  language: string,
): InstallationReportSelfInspectionItem => ({
  id: definition.id,
  label: definition.label,
  text:
    definition.translations[language]?.text ??
    definition.translations.en?.text ??
    definition.label,
  action: definition.definitionType === 'CHECKBOX' ? 'CHECKBOX' : 'IMAGE_FILE',
  isRequired: definition.isRequired,
  canBeNotApplicable: !!definition.canBeNotApplicable,
});
